import moment from "moment";
import _ from "lodash";

import { DAYS_OF_WEEK, MONTHS_OF_YEAR } from "../../constants";
import { monthSort } from "../helpers";

/**
 * @typedef {import('./compactRules').Schedule} Schedule
 */

const createEmptyRule = () => ({
  startTime: "",
  endTime: "",
  week_days: [],
  month_days: [],
  months: [],
});

const daysOfTheWeek = DAYS_OF_WEEK.map((daysOfWeek) => daysOfWeek.toLowerCase());

const ruleSplitter = (timeSpan) => {
  const weekdays = [];

  const startTime = moment.utc(`${timeSpan.startTime}`, "YYYY-MM-DDT HH:mm").toISOString();
  const endTime = moment.utc(`${timeSpan.endTime}`, "YYYY-MM-DDT HH:mm").toISOString();

  weekdays.push(daysOfTheWeek[moment.utc(startTime).day()]);
  weekdays.push(daysOfTheWeek[moment.utc(endTime).day()]);

  return {
    startTime: timeSpan.startTime.slice(11, 16),
    endTime: timeSpan.endTime.slice(11, 16),
    week_days: [...new Set(weekdays)],
    month_days: [],
    months: [],
  };
};

/**
 * @typedef DayOfWeekRuleCreatorProps
 * @prop {Array} daysOfWeekSpan
 * @prop {string[]} week_days
 * @prop {string} scheduleName
 * @prop {string[]} monthSelection
 */

/**
 * @param {DayOfWeekRuleCreatorProps} formObject
 * @returns {Schedule}
 */
export default (formObject) => {
  if (_.isEmpty(formObject)) {
    return null;
  }

  const rulesFromDateTimeSpan = formObject.daysOfWeekSpan;
  const weekDays = formObject.week_days;
  const scheduleName = formObject.scheduleName;

  const rules = [];

  if (rulesFromDateTimeSpan.length < 1 || weekDays.length < 1) {
    return {
      scheduleName,
      rules,
    };
  }

  const startMonth =
    MONTHS_OF_YEAR[moment.utc(rulesFromDateTimeSpan[0].startTime).month()].toLowerCase();

  for (let i = 0; i < rulesFromDateTimeSpan.length; i++) {
    const splitRule = ruleSplitter(rulesFromDateTimeSpan[i]);
    const newRule = createEmptyRule();

    newRule.startTime = splitRule.startTime;
    newRule.endTime = splitRule.endTime;
    newRule.week_days = splitRule.week_days;
    newRule.month_days = splitRule.month_days;
    newRule.months = _.uniq([startMonth, ...formObject.monthSelection]).sort(monthSort);
    rules.push(newRule);
  }

  for (let i = 0; i < weekDays.length; i++) {
    const currentDay = weekDays[i];
    rules[0].week_days.push(currentDay);
    rules[0].week_days = _.uniq(rules[0].week_days);

    if (rules.length > 1) {
      const indexOfTheCurrentDay = daysOfTheWeek.indexOf(currentDay);
      const indexOfTheNextDay = (indexOfTheCurrentDay + 1) % 7;
      const nextDay = daysOfTheWeek[indexOfTheNextDay];
      rules[1].week_days.push(nextDay);
      rules[1].week_days = _.uniq(rules[1].week_days);
    }
  }

  return {
    scheduleName,
    rules,
  };
};
